import React, { useContext, useEffect, useRef } from 'react';
import cn from 'classnames';
import { Input } from '@ferris/react/components/forms';
import { Button, Loader } from '@ferris/react';
import { CompetitorUrlContext, CALL_STATUS, CallStatusContext } from '../Context';
import { BaseComponentProptypes } from '../properties';

const BaseComponent = (props) => {
    const {
        error,
        loading,
        callStatus,
        executeCall,
        executeRemove
    } = useContext(CallStatusContext);
    const {
        setCompetitorUrl,
        competitorUrl
    } = useContext(CompetitorUrlContext);
    const {
        placeholder,
        ctaConfirm,
        ctaCancel,
        title,
        description
    } = props;

    const inputHandler = ({ target: { value } }) => {
        setCompetitorUrl(value);
    };

    // button handlers
    const confirmHandler = () => {
        executeCall();
    };
    const removeHandler = () => {
        executeRemove();
    };

    const inputRef = useRef(null);
    const confirmButtonRef = useRef(null);
    const onKeyDown = (e) => {
        if (e.key === 'Enter' && confirmButtonRef.current) {
            confirmButtonRef.current.click();
        }
    };
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.addEventListener('keydown', onKeyDown);
        }
    }, []);
    // buttons
    const ConfirmButton = () => {
        if ([CALL_STATUS.PREFILLED, CALL_STATUS.SUCCESS].includes(callStatus)) return null;
        return (
            <Button
                htmlButtonType="button"
                type="primary"
                data-wdio="competitor-url-button"
                id="competitor-url-button"
                onClick={confirmHandler}
                disabled={loading || !competitorUrl || !!error}
                parentRef={confirmButtonRef}
            >
                {ctaConfirm}
            </Button>
        );
    };
    const RemoveButton = () => {
        if (![CALL_STATUS.PREFILLED, CALL_STATUS.SUCCESS].includes(callStatus)) return null;
        return (
            <Button
                htmlButtonType="button"
                type="utility"
                variant="utility-standard"
                data-wdio="competitor-url-button-remove"
                id="competitor-url-button-remove"
                onClick={removeHandler}
                disabled={loading}
            >
                {ctaCancel}
            </Button>
        );
    };
    const isDisabled = () => [
        CALL_STATUS.SUCCESS,
        CALL_STATUS.LOADING,
        CALL_STATUS.PREFILLED
    ].includes(callStatus);
    return (
        <div className={cn(
            'competitor-url-component',
            { 'competitor-url-component--loading': loading }
        )}
        >
            <Loader
                classes={cn('competitor-url-component__loader', {
                    'competitor-url-component__loader--loading': loading
                })}
                visible={loading}
            />
            <div className={cn('competitor-url-component__header')}>
                <p><b>{title}</b></p>
                <p>{description}</p>
            </div>
            <div className={cn('competitor-url-component__content')}>
                <div className={cn('competitor-url-component__input')}>
                    <Input
                        iconName={[CALL_STATUS.PREFILLED, CALL_STATUS.SUCCESS].includes(callStatus) ? 'check-circle' : ''}
                        type="text"
                        disabled={isDisabled()}
                        onChange={inputHandler}
                        value={competitorUrl}
                        label={placeholder}
                        floatLabel
                        invalid={!!error}
                        validationMessage={error}
                        parentRef={inputRef}
                        id="competitor-url-link-input"
                    />
                </div>
                <div className={cn('competitor-url-component__buttons')}>
                    <ConfirmButton />
                    <RemoveButton />
                </div>
            </div>
        </div>
    );
};

BaseComponent.propTypes = BaseComponentProptypes;

export default BaseComponent;
